import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'attachmentTooltip', standalone: true, pure: true })
export class AttachmentTooltipPipe implements PipeTransform {
	transform(attachmentsByItem: Record<number, File[]> | undefined, invoiceId: number): string {
		const count = attachmentsByItem?.[invoiceId]?.length ?? 0;
		return count > 0 ? `${count} załączników – kliknij, aby edytować` : 'Dodaj załączniki';
	}
}
